import { GridColumnWidthState } from 'widgets/store/grid/columnWidth/GridColumnWidthState';
import {
    SetGridColumnWidthAction,
    SetGridColumnWidthPayload,
} from 'widgets/store/grid/columnWidth/actions';
import { WidgetActionType } from 'widgets/store/actions';
import { Action } from 'store/store';
import { Reducer } from 'redux';
import { WidgetType } from 'widgets/WidgetType';

export const createColumnWidthsReducer = <
    TColumnId extends string,
    TState extends GridColumnWidthState<TColumnId>,
>(
    widgetType: WidgetType,
    initialState: TState
): Reducer<TState, SetGridColumnWidthAction<TColumnId>> => {
    return (
        state = initialState,
        action: Action<string, SetGridColumnWidthPayload<TColumnId> | undefined>
    ) => {
        if (!action.payload || !action.payload) {
            return state;
        }
        if (action.payload.widgetType !== widgetType) {
            return state;
        }
        switch (action.type) {
            case WidgetActionType.WIDGET_SET_GRID_COLUMN_WIDTH:
                return {
                    ...state,
                    columnWidths: {
                        ...state.columnWidths,
                        [action.payload!.columnId!]: action.payload!.width,
                    },
                };

            default:
                return state;
        }
    };
};
